import React from "react";
import style from "./index.module.scss";
interface AverageProps {
    title: string;
    totalScore?: string; //分数
    grade?: string | number; //占比
}
export default function Average({ title, totalScore, grade }: AverageProps) {
    return (
        <div className={style.average}>
            <span />
            <span>{title}</span>
            <span>(占总成绩{grade}%)&nbsp;&nbsp;</span>
            <span>当前分数</span>
            <span>&nbsp;{totalScore}&nbsp;</span>
            <span>分</span>
        </div>
    );
}
